module.exports = __webpack_public_path__ + "img/smiling-face-with-smiling-eyes.7f0ae6b9.png";